<template>
  <v-flex xs12 sm6 md4 lg3>
    <v-card class="text-center ma-3" color="#FFF0F5">
      <v-card-title>
        <v-row align="center" no-gutters>
          <v-col cols="auto">
            <!-- Icon -->
            <!-- <v-icon color="primary">mdi-message-text</v-icon> -->
            <v-btn fab depressed small dark color="#fff">
              <v-icon color="#FF66CC">mdi-sync-circle</v-icon>
            </v-btn>
          </v-col>
          <v-col>
            <!-- Name -->
            <div align="left" class="ml-4">
              <span class="text-h6 subheading cardText--text">QuickSwap</span>
            </div>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text align="left" class="ml-3">
        <!-- Amount -->
        <div
          v-if="quickSwap"
          class="text-h6 cardTextAccent3--text font-weight-bold"
        >
          Kes. {{ quickSwap.data.quickSwap.balance.toFixed(1) }}
        </div>
        <div v-else class="text-h6 cardTextAccent3--text font-weight-bold">
          Kes. 0
        </div>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  created() {
    this.$store.dispatch("wallets/fetchQuickSwap");
  },
  computed: {
    quickSwap() {
      return this.$store.getters["wallets/quickSwap"];
    },
  },
};
</script>
